import CartPage from './CartPage.vue'
import CartOrcamento from './CartOrcamento.vue'

export default {
    'cart-page': CartPage,
    'cart-orcamento': CartOrcamento
}
